import { LANGUAGE_COOKIE_NAME, normalizeLanguageCode, resolveLanguageCode } from '@/i18n/config';

const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export function readLanguageCookie(): string | null {
  if (typeof document === 'undefined') return null;
  const prefix = `${LANGUAGE_COOKIE_NAME}=`;
  const value = document.cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix))
    ?.slice(prefix.length);
  return resolveLanguageCode(value ? decodeURIComponent(value) : null);
}

export function writeLanguageCookie(languageCode: string): void {
  if (typeof document === 'undefined') return;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${LANGUAGE_COOKIE_NAME}=${encodeURIComponent(normalizeLanguageCode(languageCode))}; Path=/; Max-Age=${COOKIE_MAX_AGE}; SameSite=Lax${secure}`;
}
